/* eslint-disable import/no-anonymous-default-export */
import ToastConstants from './ToastConsts'

const initialState = {
    visible: false,
    timeout: 3000,
    message: '',
    type: 'success', // error | warning | info | success
}

export default (state = initialState, action) => {
    switch (action.type) {
        case ToastConstants.SET_TOAST:
            {
                return {
                    ...state,
                    visible: true,
                    timeout: action.payload.timeout,
                    message: action.payload.message,
                    type: action.payload.type,
                }
            }
        case ToastConstants.DISABLE_TOAST:
            return {
                ...state,
                visible: false,
            }
        default:
            return state
    }
}
